import { useSidebarStore } from '~/lib/store/sidebar';

// Version stamp: wired to read package.json via vite `define` in Phase 5.C.8; fallback until then.
const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '2.0.0-alpha';

/** Sticky version row at the bottom of the sidebar. Hidden when collapsed. */
export function SidebarFooter() {
	const collapsed = useSidebarStore(s => s.collapsed);
	if (collapsed) return null;
	return (
		<div className="mt-auto border-t border-border-subtle">
			<div className="flex items-center gap-2 px-2.5 py-2 text-[10.5px] text-foreground-subtle" title={`v${APP_VERSION}`}>
				<span className="shrink-0 tabular-nums">v{APP_VERSION}</span>
			</div>
		</div>
	);
}
